export default __webpack_public_path__ + "static/media/facebook-Contactus.e532de99.svg";